import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout/DashboardLayout';
import Login from './Login/Login'
import Layout from './components/Layout/Layout';
import AddEmployee from './components/Forms/Employee/AddEmployee'
import AddSite from './components/Forms/Site/AddSite';
import AddVisitor from './components/Forms/Visitor/AddVisitor';
import AddVisitorForm from './components/Forms/Visitor/AddVisitorForm';
import ViewManager from './components/ViewTable/ViewEmployee';
import ViewConcierge from './components/Forms/Concierge/Concierge';
import ViewVisitors  from './components/ViewTable/ViewVisitors';
import ViewSite from './components/ViewTable/ViewSite';
import ViewVisitorTypes from './components/VisitorTypes/ViewVisitorTypes';
import ProtectedRoute  from './components/ProtectedRoutes/ProtectedRoute';
import TimeInVisitors from './components/ViewTable/TimeInVisitors';
import TimeOutVisitors from './components/ViewTable/TimeOutVisitors';
import ChangePassword from './components/ChangePassword/ChangePass';
import ForgotPassword from './components/ForgotPassword/ForgotPass';
import ResetPassword from './components/ResetPassword/ResetPass';
import ViewManagerVisitors from './components/ViewTable/ViewManagerVisitors';
import ViewManagerTimeInVisitors from './components/ViewTable/ViewManagerTimeInVisitors';
import ViewManagerTimeOutVisitors from './components/ViewTable/ViewManagerTimeOutVisitors';


function App() { 
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    <> 
  <BrowserRouter>
  <Routes>

  <Route path="/" element={<Login />} />
    
          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <  DashboardLayout/>
              </ProtectedRoute>
            }
          />


    <Route
          path="/employeeform"
          element={
            <ProtectedRoute>
            <Layout>
              <AddEmployee />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
          path="/siteform"
          element={
            <ProtectedRoute>
            <Layout>
              <AddSite />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
          path="/visitorform"
          element={
            <ProtectedRoute>
            <Layout>
              <AddVisitor />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
          path="/addVisitor"
          element={
            <ProtectedRoute>
            <Layout>
              <AddVisitorForm />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
          path="/viewManagers"
          element={
            <ProtectedRoute>
            <Layout>
              <ViewManager />
            </Layout>
            </ProtectedRoute>
          }
        />

        
<Route
          path="/viewConcierge"
          element={
            <ProtectedRoute>
            <Layout>
              <ViewConcierge />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
          path="/viewVisitors"
          element={
            <ProtectedRoute>
            <Layout>
              <ViewVisitors />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
          path="/timeInVisitors"
          element={
            <ProtectedRoute>
            <Layout>
              <TimeInVisitors />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
          path="/timeOutVisitors"
          element={
            <ProtectedRoute>
            <Layout>
              <TimeOutVisitors />
            </Layout>
            </ProtectedRoute>
          }
        />

<Route
  path="/viewsites"
  element={
    (() => {

      if (user?.role === 'SUPERADMIN') {
        return (
          <ProtectedRoute>
            <Layout>
              <ViewSite />
            </Layout>
          </ProtectedRoute>
        );
      } else {
        // Redirect unauthorized users
        return null;
      }
    })()
  }
/>
<Route
  path="/viewManagerVisitors"
  element={
    (() => {

      if (user?.role !== 'SUPERADMIN') {
        return (
          <ProtectedRoute>
            <Layout>
              <ViewManagerVisitors />
            </Layout>
          </ProtectedRoute>
        );
      } 
    })()
  }
/>

<Route
  path="/viewManagerTimeInVisitors"
  element={
    (() => {

      if (user?.role !== 'SUPERADMIN') {
        return (
          <ProtectedRoute>
            <Layout>
              <ViewManagerTimeInVisitors />
            </Layout>
          </ProtectedRoute>
        );
      
      }
    })()
  }
/>


<Route
  path="/viewManagerTimeOutVisitors"
  element={
    (() => {

      if (user?.role !== 'SUPERADMIN') {
        return (
          <ProtectedRoute>
            <Layout>
              <ViewManagerTimeOutVisitors />
            </Layout>
          </ProtectedRoute>
        );
      
      }
    })()
  }
/>




<Route
          path="/viewvisitortypes"
          element={
            <ProtectedRoute>
            <Layout>
              <ViewVisitorTypes />
            </Layout>
            </ProtectedRoute>
          }
        />

        
<Route
          path="/changePassword"
          element={
            <ProtectedRoute>
      
              <ChangePassword />
         
            </ProtectedRoute>
          }
        />

<Route
          path="/forgotPassword"
          element={
              <ForgotPassword/>
          }
        />

        
<Route
          path="/reset-password/:token"
          element={
              <ResetPassword/>
          }
        />


  </Routes>
  </BrowserRouter>
  </>
  );
}

export default App;


